<template>
  <v-card flat class="tab-card-client">
    <cs-button
      id="newClient"
      class="create-new-client-button"
      primary
      label="Create New User"
      @click="showNewUserModal('new', '')"
    ></cs-button>
    <cs-button
      v-if="!isHubEnabled"
      id="client-user-list--user-import-button"
      class="create-new-client-button"
      primary
      label="Import Users"
      @click="setClientUserImportModalDisplayed(true)"
    ></cs-button>
    <div class="new-client-button-clear"></div>
    <v-row no-gutters>
      <v-col cols="2" class="filter-by">FILTER BY:</v-col>
      <v-row no-gutters>
        <v-col cols="4">
          <v-select
            id="client-user-list--client-acl-role"
            v-model="searchClientAclRole"
            color="primary"
            placeholder="Select Client ACL Role"
            :items="clientAclRoles"
            variant="underlined"
            single-line
            @update:model-value="getUserFilterData(true)"
          >
            <template #item="data">
              <v-list-item
                v-bind="data.props"
                :id="`client-user-list--filter-by--client-acl-role--option-${String(
                  data.item.title
                ).replaceAll(' ', '')}`"
              >
                {{ data.item.text }}
              </v-list-item>
            </template>
          </v-select>
        </v-col>
        <v-col cols="4">
          <v-text-field
            id="client-user-list--user-email"
            v-model="searchUserEmail"
            placeholder="User Email"
            class="excursion-filter-search excursion-input"
            single-line
            variant="underlined"
            color="primary"
            type="text"
            @keydown.space.prevent
            @keyup.enter="getUserFilterData(true)"
          ></v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field
            id="client-user-list--client-name"
            v-model="searchClient"
            placeholder="Search Client Name"
            class="excursion-filter-search excursion-input"
            append-icon="mdi-magnify"
            color="primary"
            variant="underlined"
            single-line
            type="text"
            @click:append="getUserFilterData(true)"
            @keyup.enter="getUserFilterData(true)"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-row>
    <v-data-table-server
      v-model:options="pagination"
      :headers="userHeaders"
      color="primary"
      class="elevation-2 site-users-table"
      :items-per-page-options="itemsPerPageOptions"
      :items-per-page="pagination.itemsPerPage"
      :items="clientUserList"
      :loading="loading"
      :items-length="clientUserListTotal"
      no-data-text="No user was found"
      hover
    >
      <template #item="{ index, item }">
        <tr>
          <td class="site-users-name-cell">
            <a
              :id="`client-user-list--update-user--link-${index}`"
              class="client-id-label"
              @click="showUpdateUserModal(item.id)"
            >
              {{ item.id }}
            </a>
          </td>
          <td class="text-left">{{ item.email }}</td>
          <td class="text-left">{{ getUserClientName(item.clientList) }}</td>
          <td class="text-left">{{ item.created_at }}</td>
          <td class="text-left">
            <stb-icon-tooltip
              :id="getUserActionBtnId(item.id)"
              :icon-id="item.enabled ? 'fa: fas fa-check' : 'fa: fas fa-ban'"
              location="left"
              clickable
              icon-size="x-small"
              icon-color="rgb(119, 119, 119)"
              @click="displayUserEnabledConfirmationDialog(item.id, item.enabled)"
            >
              <span v-if="item.enabled">Disable</span>
              <span v-if="!item.enabled">Enable</span>
            </stb-icon-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table-server>
    <client-user-individual-modal
      v-if="clientUserIndividualModalDisplayed"
      :prop-client-user-individual-modal-refreshed="propClientUserIndividualModalRefreshed"
      :prop-user-id="propUserId"
      @reload-users="getUserFilterData"
    ></client-user-individual-modal>
    <cs-form-dialog
      id="dlg-user-enabled-confirmation"
      v-model="userEnabledConfirmationDialogDisplayed"
      heading="User Confirmation"
      body-id="userEnabledConfirmationDialog"
      :primary-action="{
        label: userEnabledConfirmationDialogButtonLabel,
        eventName: 'primary-click'
      }"
      :secondary-action1="{
        label: 'Cancel',
        eventName: 'secondary1-click'
      }"
      @primary-click="confirmUserEnabledToggle"
      @secondary1-click="userEnabledConfirmationDialogDisplayed = false"
    >
      <template #cs-form-dialog-content>
        {{ userEnabledConfirmationDialogMessage }}
      </template>
    </cs-form-dialog>
    <client-user-import-dialog
      :prop-client-user-import-modal-displayed="clientUserImportModalDisplayed"
      @modal-closed="setClientUserImportModalDisplayed"
      @user-list-imported="getUserFilterData"
    ></client-user-import-dialog>
  </v-card>
</template>

<script>
import * as types from '@/store/mutationTypes';
import aclRole from '../lib/const/aclRole';
import clientUserTableColumn from '../lib/const/clientUserTableColumn';
import ClientUserImportDialog from './ClientUserImportDialog';
import StbIconTooltip from './StbIconTooltip';
import ClientUserIndividualModal from './ClientUserIndividualModal';

export default {
  name: 'ClientUserList',

  components: {
    ClientUserImportDialog,
    StbIconTooltip,
    ClientUserIndividualModal
  },

  props: [],
  data() {
    return {
      clientUserImportModalDisplayed: false,
      clientUserIndividualModalDisplayed: false,
      userEnabledConfirmationDialogDisplayed: false,
      userEnabledConfirmationDialogMessage: '',
      userEnabledConfirmationDialogButtonLabel: '',
      userEnabledConfirmationDialogUserId: 0,
      userEnabledConfirmationDialogUserEnabled: true,
      propClientUserIndividualModalRefreshed: true,
      propUserId: '',
      itemsPerPageOptions: [
        { value: 10, title: '10' },
        { value: 30, title: '30' },
        { value: 50, title: '50' }
      ],
      pagination: {
        itemsPerPage: 30,
        page: 1,
        sortBy: []
      },
      userHeaders: [
        {
          title: clientUserTableColumn.USER_ID.label,
          key: clientUserTableColumn.USER_ID.tableColumnRef,
          headerProps: { class: 'table-header' }
        },
        {
          title: clientUserTableColumn.USER_EMAIL.label,
          key: clientUserTableColumn.USER_EMAIL.tableColumnRef,
          headerProps: { class: 'table-header' }
        },
        {
          title: clientUserTableColumn.CLIENT.label,
          key: clientUserTableColumn.CLIENT.tableColumnRef,
          headerProps: { class: 'table-header' }
        },
        {
          title: clientUserTableColumn.DATE_CREATED.label,
          key: clientUserTableColumn.DATE_CREATED.tableColumnRef,
          headerProps: { class: 'table-header' }
        },
        {
          title: clientUserTableColumn.ACTION.label,
          key: clientUserTableColumn.ACTION.tableColumnRef,
          headerProps: { class: 'table-header' },
          sortable: false
        }
      ],
      querystringRefToTableColumnRefMap: {},
      tableColumnRefToQuerystringRefMap: {},
      searchUserEmail: '',
      searchClientAclRole: null,
      searchClient: ''
    };
  },
  computed: {
    isHubEnabled() {
      return this.$store.getters['authorisation/hubEnabled'];
    },
    hubUserManagementUrl() {
      return this.$store.getters['authorisation/hubUserManagementUrl'];
    },
    clientUserList() {
      return this.$store.state.common.clientUserList.data;
    },
    loading() {
      return this.$store.state.common.clientUserList.loading;
    },
    clientUserListTotal() {
      return this.$store.state.common.clientUserList.total;
    },
    clientAclRoles() {
      const clientAclRoles = [
        { value: aclRole.CLIENT_ADMIN, title: aclRole.CLIENT_ADMIN },
        { value: aclRole.CLIENT_ADMIN_ASSISTANT, title: aclRole.CLIENT_ADMIN_ASSISTANT },
        { value: aclRole.CLIENT_APPROVER, title: aclRole.CLIENT_APPROVER },
        { value: aclRole.CLIENT_LITE_USER, title: aclRole.CLIENT_LITE_USER },
        { value: aclRole.CLIENT_USER, title: aclRole.CLIENT_USER },
        { value: aclRole.CLIENT_WATCHER, title: aclRole.CLIENT_WATCHER }
      ];
      if (this.$store.state.common.clientUserGroupRoleDisplayed) {
        clientAclRoles.push(
          { value: aclRole.CLIENT_GROUP_ADMIN, title: aclRole.CLIENT_GROUP_ADMIN },
          { value: aclRole.CLIENT_GROUP_APPROVER, title: aclRole.CLIENT_GROUP_APPROVER },
          { value: aclRole.CLIENT_GROUP_USER, title: aclRole.CLIENT_GROUP_USER },
          { value: aclRole.CLIENT_GROUP_WATCHER, title: aclRole.CLIENT_GROUP_WATCHER }
        );
      }
      return clientAclRoles;
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getUserFilterData();
      },
      deep: true
    }
  },
  mounted() {
    Object.keys(clientUserTableColumn).forEach((key) => {
      this.querystringRefToTableColumnRefMap[clientUserTableColumn[key].querystringRef] =
        clientUserTableColumn[key].tableColumnRef;
      this.tableColumnRefToQuerystringRefMap[clientUserTableColumn[key].tableColumnRef] =
        clientUserTableColumn[key].querystringRef;
    });
    const clientAclRolesValues = this.clientAclRoles.map((item) => item.value);
    if (Object.keys(this.$route.query).length !== 0) {
      const {
        's-user-email': parsedSearchUserEmail,
        's-client-acl-role': parsedSearchClientAclRole,
        's-client-name': parsedSearchClientName,
        page: parsedSearchPage,
        length: parsedSearchLength,
        direction: parsedSearchDirection,
        order: parsedSortBy
      } = this.$route.query;
      if (parsedSearchUserEmail && String(parsedSearchUserEmail).trim().length !== 0) {
        this.searchUserEmail = parsedSearchUserEmail;
      }
      if (parsedSearchClientName && String(parsedSearchClientName).trim().length !== 0) {
        this.searchClient = parsedSearchClientName;
      }
      if (
        parsedSearchClientAclRole &&
        String(parsedSearchClientAclRole).trim().length !== 0 &&
        clientAclRolesValues.indexOf(parsedSearchClientAclRole) !== -1
      ) {
        this.searchClientAclRole = parsedSearchClientAclRole;
      }
      if (
        parsedSearchLength === '10' ||
        parsedSearchLength === '30' ||
        parsedSearchLength === '50'
      ) {
        this.pagination.itemsPerPage = parseInt(parsedSearchLength, 10);
      } else {
        this.pagination.itemsPerPage = 30;
      }
      if (!Number.isNaN(parseInt(parsedSearchPage, 10)) && parseInt(parsedSearchPage, 10) > 0) {
        this.pagination.page = parseInt(parsedSearchPage, 10);
      }
      if (
        clientUserTableColumn.USER_ID.querystringRef === parsedSortBy ||
        clientUserTableColumn.USER_EMAIL.querystringRef === parsedSortBy ||
        clientUserTableColumn.CLIENT.querystringRef === parsedSortBy ||
        clientUserTableColumn.DATE_CREATED.querystringRef === parsedSortBy ||
        clientUserTableColumn.ACTION.querystringRef === parsedSortBy
      ) {
        this.pagination.sortBy[0] = {
          key: this.querystringRefToTableColumnRefMap[parsedSortBy],
          order: 'asc'
        };
        if (parsedSearchDirection === 'DESC' || parsedSearchDirection === 'ASC') {
          this.pagination.sortBy[0].order = parsedSearchDirection.toLowerCase();
        }
      }
    }
  },
  methods: {
    getUserActionBtnId(id) {
      return `client-user-list--client-user-button-${id}`;
    },
    displayUserEnabledConfirmationDialog(userId, enabled) {
      if (enabled) {
        this.userEnabledConfirmationDialogMessage = 'Are you sure you want to disable this user?';
        this.userEnabledConfirmationDialogButtonLabel = 'Disable';
      } else {
        this.userEnabledConfirmationDialogMessage = 'Are you sure you want to enable this user?';
        this.userEnabledConfirmationDialogButtonLabel = 'Enable';
      }
      this.userEnabledConfirmationDialogUserId = userId;
      this.userEnabledConfirmationDialogDisplayed = true;
      this.userEnabledConfirmationDialogUserEnabled = !enabled;
    },
    async confirmUserEnabledToggle() {
      const store = this.$store;
      const requestParam = {
        enabled: this.userEnabledConfirmationDialogUserEnabled
      };
      const argHash = {
        id: this.userEnabledConfirmationDialogUserId,
        payload: requestParam,
        store: this.$store
      };
      const response = await this.$app.stbApiAdapter.putClientUserEnabled(argHash);
      if (!response.error) {
        store.dispatch('common/toggleClientUserEnabled', this.userEnabledConfirmationDialogUserId);
      }
      this.userEnabledConfirmationDialogDisplayed = false;
    },
    showNewUserModal() {
      if (this.isHubEnabled) {
        if (this.hubUserManagementUrl) {
          window.location.assign(this.hubUserManagementUrl);
          return;
        }
        console.warn('Hub enabled but hubUserManagementUrl is empty; falling back to local modal');
      }
      this.clientUserIndividualModalDisplayed = true;
      this.propClientUserIndividualModalRefreshed = !this.propClientUserIndividualModalRefreshed;
      this.propUserId = '';
    },
    showUpdateUserModal(userId) {
      this.clientUserIndividualModalDisplayed = true;
      this.propClientUserIndividualModalRefreshed = !this.propClientUserIndividualModalRefreshed;
      this.propUserId = `${userId}`;
    },
    getUserClientName(clientList) {
      return clientList && clientList.length > 0 && clientList[0].metadata
        ? clientList[0].metadata.name
        : '';
    },
    resetPage() {
      this.pagination.itemsPerPage = 30;
      this.pagination.page = 1;
      this.pagination.sortBy = [];
    },
    async getUserFilterData(isResetPage = false) {
      if (isResetPage) {
        this.resetPage();
      }
      this.$store.commit(types.COMMON_SET_CLIENT_USER_LIST_LOADING, true);
      const filterParam = {
        's-user-email': this.searchUserEmail.trim(),
        's-client-acl-role': this.searchClientAclRole || '',
        's-client-name': this.searchClient,
        page: this.pagination.page,
        length: this.pagination.itemsPerPage
      };

      Object.keys(filterParam).forEach((key) => {
        if (filterParam[key] === '') {
          delete filterParam[key];
        }
      });

      const searchQuery = JSON.parse(JSON.stringify(filterParam));
      if (this.pagination.sortBy.length !== 0 && this.pagination.sortBy[0] !== '') {
        searchQuery.order = this.tableColumnRefToQuerystringRefMap[this.pagination.sortBy[0].key];
        filterParam.order = this.pagination.sortBy[0].key;
        if (this.pagination.sortBy[0].order) {
          searchQuery.direction = this.pagination.sortBy[0].order.toUpperCase();
          filterParam.direction = this.pagination.sortBy[0].order.toUpperCase();
        }
      }

      const argHash = {
        stbApiAdapter: this.$app.stbApiAdapter,
        filterParam,
        store: this.$store
      };
      await this.$store.dispatch('common/getClientUserList', argHash);
      this.$router.replace({ query: searchQuery }, () => {});
    },
    setClientUserImportModalDisplayed(displayed) {
      this.clientUserImportModalDisplayed = displayed;
    }
  }
};
</script>

<style scoped>
.site-users-name-cell a {
  color: #c80063;
  text-decoration: none;
  padding-left: 8px;
  cursor: pointer;
}

.site-users-name-cell a:not([href]):not([tabindex]) {
  color: #c80063;
  text-decoration: none;
  padding-left: 8px;
}

.site-users-table table.v-table > thead > tr > th:first-child {
  padding: 0 16px;
}

.site-users-table :deep(.table-header) {
  font-size: 12px !important;
  font-weight: bolder !important;
  color: #000 !important;
  padding: 0 5px;
}

.site-users-table tr td {
  font-size: 13px !important;
  font-weight: 400 !important;
  padding: 0 5px !important;
}
</style>
